"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/prefer-stateless-function */
// TODO Make SubBar a pure component
var react_1 = __importDefault(require("react"));
var breadcrumb_route_1 = __importDefault(require("./breadcrumb-route"));
var SubBar = /** @class */ (function (_super) {
    __extends(SubBar, _super);
    function SubBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubBar.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "acc-content-subbar" },
            react_1.default.createElement(breadcrumb_route_1.default, null)));
    };
    return SubBar;
}(react_1.default.Component));
exports.default = SubBar;
//# sourceMappingURL=index.js.map